var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content md no-padding flex-box vertical"},[_c('RoleForm',{ref:"addForm",staticClass:"add-form-box",attrs:{"initial":_vm.initial}}),_c('a-space',{staticClass:"footer"},[_c('a-button',{on:{"click":_vm.handleCancel}},[_vm._v("取消")]),_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.handleConfirm}},[_vm._v("保存")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }